<template>
  <div>
    <div class="title-lable-error">
      <span class="ml-3">{{ $t('rentalNotification.noMachineAvailableTitle') }}</span>
    </div>
    <div
      class="d-flex flex-row align-items-center mt-3 ml-3"
      style="color: #757575; font-size: 0.85rem"
    >
      <p>
        {{ $t('rentalNotification.oneInListNoMachineMessage') }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  methods: {},
};
</script>